import { Link } from "react-router-dom";
import { useAuth, useGet } from "@/context/AuthContext";

export default function TrialProgress() {
  const { state, user } = useAuth();
  const trial = state?.status === "trialing";
  const { data } = useGet(trial && user?.role === "owner" ? "/trial-progress" : null);
  if (!trial || !data) return null;
  const ending = data.days_left != null && data.days_left <= 3;
  return (
    <div className="card-surface p-5 mb-8" data-testid="trial-progress">
      <div className="flex flex-col md:flex-row md:items-center justify-between gap-3">
        <div>
          <div className="font-display text-xl">{ending ? `Your trial ends in ${data.days_left} day${data.days_left === 1 ? "" : "s"}.` : "Your 86'd so far"}</div>
          <p className="text-sm text-stone-600">{ending ? "Choose a plan to keep everything you've set up. Your data stays put." : `${data.days_left} days left in your free trial.`}</p>
        </div>
        <Link to="/app/billing" className="h-11 px-5 rounded-full bg-stone-900 text-white text-sm font-semibold inline-flex items-center justify-center" data-testid="trial-choose-plan">Choose Plan</Link>
      </div>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-3 mt-4">
        {data.items.map((i) => (
          <div key={i.label} className="rounded-lg bg-[#FBF9F5] p-3" data-testid={`trial-stat-${i.label.toLowerCase().replace(/[^a-z]+/g, "-")}`}>
            <div className="text-xl font-semibold num">{i.label === "Restaurant setup" ? (i.count ? "Done" : "—") : i.count}</div>
            <div className="text-xs text-stone-500">{i.label}</div>
          </div>))}
      </div>
    </div>
  );
}
